import { getCurrency, formatPriceCurrency } from 'utils/utils';
import { FlightDetails } from '../interfaces/FlightDetailsResponse';
import { Select } from 'ts/interfaces/Generic';
import { PassengerType } from 'constants/flight';

export class BookOptionsCatalogue {
  outboundBaggage: BoundOptions;
  outboundMeal: BoundOptions;
  inboundBaggage: BoundOptions;
  inboundMeal: BoundOptions;

  visible: boolean;
  constructor(t: any, baggageFlights?: FlightDetails[], isPair?: boolean) {
    this.outboundBaggage = {
      label: '',
      labelType: '',
      options: [],
      visible: false,
      paxTypes: [],
    };
    this.outboundMeal = {
      label: '',
      labelType: '',
      options: [],
      visible: false,
      paxTypes: [],
    };
    this.inboundBaggage = {
      label: '',
      labelType: '',
      options: [],
      visible: false,
      paxTypes: [],
    };
    this.inboundMeal = {
      label: '',
      labelType: '',
      options: [],
      visible: false,
      paxTypes: [],
    };
    baggageFlights?.forEach((flight) => {
      if (!isPair) {
        if (flight?.outbound?.listOfCatalogPrice?.length) {
          const outboundBaggage = flight.outbound.listOfCatalogPrice
            .filter((catalog) => catalog.type === 'BAG')
            .filter((item, index, self) => self.findIndex((cat) => cat.id === item.id) === index)
            .map((catalog) => {
              if (!this.outboundBaggage.paxTypes.includes(catalog.paxType)) {
                this.outboundBaggage.paxTypes.push(catalog.paxType);
                if ((catalog.paxType as unknown as PassengerType) === PassengerType.Adult) {
                  this.outboundBaggage.paxTypes.push(PassengerType.Senior.toString());
                }
              }

              const price = formatPriceCurrency(
                catalog.displayPrice.value,
                getCurrency(catalog.displayPrice.currency)
              );
              const label = catalog.descLocal || catalog.desc;
              return {
                label: `${price} - ${label}`,
                value: catalog.code,
                data: {
                  price: catalog.displayPrice.value,
                },
              };
            });

          this.outboundBaggage.options.push(...outboundBaggage);
          this.outboundBaggage.labelType = t('filter.baggage');
          this.outboundBaggage.label = `[${flight.outbound.departureAirport.cityDesc}  → ${flight.outbound.arrivalAirport.cityDesc}]`;
          this.outboundBaggage.visible = !!outboundBaggage.length;

          const outboundMeal = flight.outbound.listOfCatalogPrice
            .filter((catalog) => catalog.type === 'MEAL')
            .filter((item, index, self) => self.findIndex((cat) => cat.id === item.id) === index)
            .map((catalog) => {
              if (!this.outboundMeal.paxTypes.includes(catalog.paxType)) {
                this.outboundMeal.paxTypes.push(catalog.paxType);
                if ((catalog.paxType as unknown as PassengerType) === PassengerType.Adult) {
                  this.outboundMeal.paxTypes.push(PassengerType.Senior.toString());
                }
              }
              const price = formatPriceCurrency(
                catalog.displayPrice.value,
                getCurrency(catalog.displayPrice.currency)
              );
              const label = catalog.descLocal || catalog.desc;
              return {
                label: `${price} - ${label}`,
                value: catalog.code,
                data: {
                  price: catalog.displayPrice.value,
                },
              };
            });

          this.outboundMeal.options.push(...outboundMeal);
          this.outboundMeal.labelType = t('filter.meal');
          this.outboundMeal.label = `[${flight.outbound.departureAirport.cityDesc}  → ${flight.outbound.arrivalAirport.cityDesc}]`;
          this.outboundMeal.visible = !!outboundMeal.length;
        }
        if (flight?.inbound?.listOfCatalogPrice?.length) {
          const inboundBaggage = flight.inbound.listOfCatalogPrice
            .filter((catalog) => catalog.type === 'BAG')
            .filter((item, index, self) => self.findIndex((cat) => cat.id === item.id) === index)
            .map((catalog) => {
              if (!this.inboundBaggage.paxTypes.includes(catalog.paxType)) {
                this.inboundBaggage.paxTypes.push(catalog.paxType);
                if ((catalog.paxType as unknown as PassengerType) === PassengerType.Adult) {
                  this.inboundBaggage.paxTypes.push(PassengerType.Senior.toString());
                }
              }

              const price = formatPriceCurrency(
                catalog.displayPrice.value,
                getCurrency(catalog.displayPrice.currency)
              );
              const label = catalog.descLocal || catalog.desc;
              return {
                label: `${price} - ${label}`,
                value: catalog.code,
                data: {
                  price: catalog.displayPrice.value,
                },
              };
            });

          this.inboundBaggage.options.push(...inboundBaggage);
          this.inboundBaggage.labelType = t('filter.baggage');
          this.inboundBaggage.label = `[${flight.inbound.departureAirport.cityDesc}  → ${flight.inbound.arrivalAirport.cityDesc}]`;
          this.inboundBaggage.visible = !!inboundBaggage.length;

          const inboundMeal = flight.inbound.listOfCatalogPrice
            .filter((catalog) => catalog.type === 'MEAL')
            .filter((item, index, self) => self.findIndex((cat) => cat.id === item.id) === index)
            .map((catalog) => {
              if (!this.inboundMeal.paxTypes.includes(catalog.paxType)) {
                this.inboundMeal.paxTypes.push(catalog.paxType);
                if ((catalog.paxType as unknown as PassengerType) === PassengerType.Adult) {
                  this.inboundMeal.paxTypes.push(PassengerType.Senior.toString());
                }
              }
              const price = formatPriceCurrency(
                catalog.displayPrice.value,
                getCurrency(catalog.displayPrice.currency)
              );
              const label = catalog.descLocal || catalog.desc;
              return {
                label: `${price} - ${label}`,
                value: catalog.code,
                data: {
                  price: catalog.displayPrice.value,
                },
              };
            });

          this.inboundMeal.options.push(...inboundMeal);
          this.inboundMeal.labelType = t('filter.meal');
          this.inboundMeal.label = `[${flight.inbound.departureAirport.cityDesc}  → ${flight.inbound.arrivalAirport.cityDesc}]`;
          this.inboundMeal.visible = !!inboundMeal.length;
        }
      } else {
        if (flight?.outbound?.listOfCatalogPrice?.length) {
          const inboundBaggage = flight.outbound.listOfCatalogPrice
            .filter((catalog) => catalog.type === 'BAG')
            .filter((item, index, self) => self.findIndex((cat) => cat.id === item.id) === index)
            .map((catalog) => {
              if (!this.inboundBaggage.paxTypes.includes(catalog.paxType)) {
                this.inboundBaggage.paxTypes.push(catalog.paxType);
                if ((catalog.paxType as unknown as PassengerType) === PassengerType.Adult) {
                  this.inboundBaggage.paxTypes.push(PassengerType.Senior.toString());
                }
              }

              const price = formatPriceCurrency(
                catalog.displayPrice.value,
                getCurrency(catalog.displayPrice.currency)
              );
              const label = catalog.descLocal || catalog.desc;
              return {
                label: `${price} - ${label}`,
                value: catalog.code,
                data: {
                  price: catalog.displayPrice.value,
                },
              };
            });

          this.inboundBaggage.options.push(...inboundBaggage);
          this.inboundBaggage.labelType = t('filter.baggage');
          this.inboundBaggage.label = `[${flight.outbound.departureAirport.cityDesc}  → ${flight.outbound.arrivalAirport.cityDesc}]`;
          this.inboundBaggage.visible = !!inboundBaggage.length;

          const inboundMeal = flight.outbound.listOfCatalogPrice
            .filter((catalog) => catalog.type === 'MEAL')
            .filter((item, index, self) => self.findIndex((cat) => cat.id === item.id) === index)
            .map((catalog) => {
              if (!this.inboundMeal.paxTypes.includes(catalog.paxType)) {
                this.inboundMeal.paxTypes.push(catalog.paxType);
                if ((catalog.paxType as unknown as PassengerType) === PassengerType.Adult) {
                  this.inboundMeal.paxTypes.push(PassengerType.Senior.toString());
                }
              }
              const price = formatPriceCurrency(
                catalog.displayPrice.value,
                getCurrency(catalog.displayPrice.currency)
              );
              const label = catalog.descLocal || catalog.desc;
              return {
                label: `${price} - ${label}`,
                value: catalog.code,
                data: {
                  price: catalog.displayPrice.value,
                },
              };
            });

          this.inboundMeal.options.push(...inboundMeal);
          this.inboundMeal.labelType = t('filter.meal');
          this.inboundMeal.label = `[${flight.outbound.departureAirport.cityDesc}  → ${flight.outbound.arrivalAirport.cityDesc}]`;
          this.inboundMeal.visible = !!inboundMeal.length;
        }
      }
    });

    this.visible =
      this.inboundBaggage.visible ||
      this.inboundMeal.visible ||
      this.outboundBaggage.visible ||
      this.outboundMeal.visible;
  }
}

export interface BoundOptions {
  label: string;
  labelType: string;
  options: Select[];
  visible: boolean;
  paxTypes: string[];
}
